import { GKSearchSelect, GKTextField, Grid2, Show } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { validateNotWhitespaceOnly } from "utils/validationSchema";

const BasicInfoTab = ({ isDisable }: { isDisable: boolean }) => {
  const form = useFormContext();

  const clientList = useAppSelector((state) => state?.app?.clientList);
  const partnerList = useAppSelector((state) => state?.app?.partnerList);
  const brokerList = useAppSelector(
    (state) => state?.portfolio?.extraThings?.brokerList,
  );

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={3}>
        <Controller
          name="portfolio.name"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel="Portfolio name"
              slotProps={{ htmlInput: { readOnly: isDisable } }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={3}>
        <Controller
          name="portfolio.portfolioId"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel="Portfolio Code"
              slotProps={{ htmlInput: { readOnly: isDisable } }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={3}>
        <Controller
          name="portfolio.committedValue"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel="Committed Value"
              type="number"
              slotProps={{ htmlInput: { readOnly: isDisable } }}
            />
          )}
        />
      </Grid2>
      <Grid2 size={3}>
        <Controller
          name="portfolio.client"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              {...field}
              disableClearable
              options={clientList || []}
              getOptionLabel={(option) => option?.name || option}
              inputLabel="Client"
              onChange={(event, val) => field.onChange(val?.id)}
              value={
                clientList?.find((data: any) => data?.id === field.value)?.name
              }
              readOnly={isDisable}
            />
          )}
        />
      </Grid2>
      <Grid2 size={3}>
        <Controller
          name="portfolio.partners"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              inputLabel="Partner"
              options={partnerList || []}
              value={
                partnerList?.filter((option: { value: string | number }) =>
                  field.value?.includes(+option.value),
                )[0]?.name || []
              }
              onChange={(e, val) => {
                field.onChange(val?.value ? [val.value] : []);
              }}
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2>

      <Grid2 size={3}>
        <Controller
          name="portfolio.broker"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              disableClearable
              inputLabel="Select Broker"
              options={brokerList}
              value={
                brokerList?.find((broker) => broker.value === field.value)
                  ?.name || ""
              }
              onChange={(e, val) => {
                field.onChange(val?.value);
                form.setValue("portfolio.otherBrokerName", "");
              }}
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2>
      <Show.When isTrue={form.watch("portfolio.broker") === "OTHER"}>
        <Grid2 size={3}>
          <Controller
            name="portfolio.otherBrokerName"
            control={form.control}
            rules={{
              required: {
                value: true,
                message: "Please enter broker name",
              },
              validate: validateNotWhitespaceOnly,
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <GKTextField
                  {...field}
                  inputLabel="Broker Name"
                  requiredField
                  error={!!error}
                  helperText={error?.message}
                />
              );
            }}
          />
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default BasicInfoTab;
